'use strict';
import angular from 'angular';
import './scripts/buySheetConfig.ctrls';
import './scripts/buySheetConfig.services';

import buySheetConfigHtmlUrl from './views/buySheetConfig.html';

angular.module('buySheetConfig', ['buySheetConfig.ctrls', 'buySheetConfig.services'])

    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('buySheetConfig', {
                parent: 'layout',
                url: '/admin/buySheetConfig',
                templateUrl: buySheetConfigHtmlUrl,
                controller: 'BuySheetConfigController',
                controllerAs: 'vm'
            })
    }]);